// import consts from "@/consts.js";
import Request from './request';


async function fetch(data) {// 获取优惠券一览
    return Request('get', "api/coupons/index", data);
}

async function fetchOne(id) {// 获取单个
    return Request('get', "api/coupons/view/" + id);
}

async function addCoupons(data) {//创建新的优惠券
    return Request('post', "api/coupons/add", data);
}

async function cancel(id) {// 作废优惠券
    return Request("post", "api/coupons/cancel", {id:id})
}

async function receiveHistories(data) {// 优惠券领取记录
    return Request("get", "api/coupons/receive-histories", data)
}

export default {
    fetch,
    fetchOne,
    addCoupons,
    cancel,
    receiveHistories,
};